module.exports = __webpack_public_path__ + "static/your-stylist-result-2-7c155e50388ea9e36574c4ec205f75f4.png";